import { Box, Button, Flex, Progress, Text, Textarea } from "@chakra-ui/react";
import { ChangeEvent, useState } from "react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import Tesseract from "tesseract.js";
import { useGenerateRecipeFromText } from "../../../hooks";

type FormInputs = {
  extractedText: string;
};

type Props = {
  onBack?: () => void;
  onSave?: () => void;
};

const ImageOCRForm = ({ onSave }: Props) => {
  const [isLoading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [extractedText, setExtractedText] = useState("");
  const { generateRecipeFromText, isLoading: generateLoading } =
    useGenerateRecipeFromText({});

  const methods = useForm<FormInputs>();

  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = methods;

  const onSubmit: SubmitHandler<FormInputs> = (data) => {
    generateRecipeFromText(data.extractedText);
    toast.loading(
      "We're currently processing this recipe. it can take between 30-60 seconds to generate it. Keep this page open and we'll let you know when it's ready!",
      { duration: 15000 }
    );
    onSave && onSave();
    console.log(data);
  };

  const handleFileChange = async (e: ChangeEvent<HTMLInputElement>) => {
    setLoading(true);
    const files = e.target.files;
    let processedFiles = 0;

    if (!files) {
      return;
    }

    for (let file of files) {
      await Tesseract.recognize(file, "eng", {
        logger: (m) => {
          // Update the progress as each file is being processed
          const fileProgress = (processedFiles + m.progress) / files.length;
          setProgress(Math.round(fileProgress * 100));
        },
      })
        //   .then(({ data: { text } }) => {
        //     setExtractedText((prevText) => prevText + "\n" + text);
        //     processedFiles++;
        //   });
        .then((result) => {
          console.log(result.data.text);
          const text = result.data.text;
          setExtractedText((prevText) => {
            const newText = prevText + "\n" + text;
            setValue("extractedText", newText);
            return newText;
          });
          processedFiles++;
        });
    }

    setLoading(false);
    // setValue("extractedText", extractedText);
    console.log(extractedText);
  };

  const wordCount = extractedText.split(/\s+/).length;

  return (
    <FormProvider {...methods}>
      <form
        onKeyPress={(e) => {
          if (e.key === "enter") {
            e.preventDefault();
          }
        }}
        // style={{ height: "100%" }}
        id="ExtractRecipeFromImage"
        onSubmit={handleSubmit(onSubmit)}
      >
        {/* <Text fontWeight={"bold"} fontSize="large">
          🔍 Extracting Text from Recipe Images
        </Text> */}
        <Flex direction={"column"} paddingLeft={5}>
          <Text>
            You can easily upload an image and we will try to extract the text
            from it.
            <br />
            If the text isnt extracted correctly - on the latest versions of iOS
            and android - you can open your photos app and select text from an
            image directly.
            <br />
            <br />
            You can then select the "Create recipe from text" option and paste
            it in there instead.
          </Text>
          <Text>
            You can upload multiple images at once, and we will extract the text
            - ensure you remove any unecessary text
          </Text>
        </Flex>
        <Flex p="25px" direction="column" gap="10px" height="100%">
          <input type="file" multiple onChange={handleFileChange} />
          {isLoading && (
            <Box>
              <Progress hasStripe value={progress} />
              <Text>{progress}%</Text>
            </Box>
          )}
          <Textarea
            {...register("extractedText")}
            placeholder="Extracted text will appear here"
          />
          {wordCount > 1000 && (
            <Text color="red.500">
              There is a maximum of 1000 words. Please remove any unnecessary
              words.
            </Text>
          )}
          <Button
            mt={4}
            colorScheme="brand"
            isLoading={isLoading}
            type="submit"
            form="ExtractRecipeFromImage"
          >
            Save
          </Button>
        </Flex>
      </form>
    </FormProvider>
  );
};

export default ImageOCRForm;
